/**
 * mt-mdnmd-product.js
 * 产品详情页交互逻辑
 * 配置数据通过页面内 <script type="application/json" data-mt-mdnmd-config> 传入
 */

(function () {
  'use strict';

  /* =====================================================
     工具函数
     ===================================================== */

  /** 格式化价格（单位：分） */
  function fmtMoney(cents) {
    const dollars = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + dollars;
  }

  /* =====================================================
     初始化入口 —— 支持多实例（同页多个 section）
     ===================================================== */

  function initInstance(configEl) {
    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      console.error('[mt-mdnmd] Failed to parse config', e);
      return;
    }

    const sectionId      = config.sectionId;
    const variantsData   = config.variants || [];
    const storefrontToken = config.storefrontToken || '';

    const root = document.getElementById('mt-mdnmd-product-' + sectionId);
    if (!root) return;

    /* --------------------------------------------------
       移动端图片轮播
       -------------------------------------------------- */
    const mobMain   = root.querySelector('#mt-mob-main-' + sectionId);
    const mobThumbs = root.querySelector('#mt-mob-thumbs-' + sectionId);
    const mobSlides = mobMain ? Array.from(mobMain.querySelectorAll('.mt-mdnmd-pd__mob-slide')) : [];
    let currentIdx  = 0;

    function goTo(idx) {
      idx = Math.max(0, Math.min(mobSlides.length - 1, idx));
      currentIdx = idx;

      // 切换幻灯片
      mobSlides.forEach(function (el, i) {
        el.classList.toggle('is-active', i === idx);
      });

      // 同步移动端缩略图高亮
      if (mobThumbs) {
        var thumbs = mobThumbs.querySelectorAll('[data-index]');
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', parseInt(t.dataset.index) === idx);
        });
        var active = mobThumbs.querySelector('.is-active');
        if (active) {
          // 手动滚动缩略图容器，避免 scrollIntoView 导致整个页面偏移
          var container = mobThumbs;
          var thumbLeft = active.offsetLeft;
          var thumbRight = thumbLeft + active.offsetWidth;
          var containerLeft = container.scrollLeft;
          var containerRight = containerLeft + container.clientWidth;
          if (thumbRight > containerRight) {
            container.scrollTo({ left: thumbRight - container.clientWidth + 16, behavior: 'smooth' });
          } else if (thumbLeft < containerLeft) {
            container.scrollTo({ left: thumbLeft - 16, behavior: 'smooth' });
          }
        }
      }
    }

    // 移动端缩略图点击
    if (mobThumbs) {
      mobThumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-index]');
        if (btn) goTo(parseInt(btn.dataset.index));
      });
    }

    // 移动端触摸滑动
    var touchStartX = 0;
    if (mobMain) {
      mobMain.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });

      mobMain.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) goTo(currentIdx + (diff > 0 ? 1 : -1));
      }, { passive: true });
    }

    /* --------------------------------------------------
       数量 +/-
       -------------------------------------------------- */
    var buyWrap = root.querySelector('.mt-mdnmd-pd__buy-wrap');
    if (buyWrap) {
      buyWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('.mt-mdnmd-pd__qty-btn');
        if (!btn) return;
        var input = buyWrap.querySelector('.mt-mdnmd-pd__qty-input');
        if (!input) return;
        var dir = parseInt(btn.dataset.dir || '0');
        input.value = Math.max(1, parseInt(input.value || '1') + dir);
      });
    }

    /* --------------------------------------------------
       变体切换（颜色 + 尺码）
       -------------------------------------------------- */
    var variantIdEl = root.querySelector('.mt-mdnmd-product-variant-id');
    var colorLabel  = root.querySelector('[data-color-label]');
    var sizeLabel   = root.querySelector('[data-size-label]');
    var priceEl     = root.querySelector('.mt-mdnmd-pd__price');

    function findVariant() {
      var selColor = (root.querySelector('.mt-mdnmd-pd__color-input:checked') || {}).value;
      var selSize  = (root.querySelector('.mt-mdnmd-pd__size-input:checked')  || {}).value;
      return variantsData.find(function (v) {
        var matchC = !selColor || v.option1 === selColor || v.option2 === selColor || v.option3 === selColor;
        var matchS = !selSize  || v.option1 === selSize  || v.option2 === selSize  || v.option3 === selSize;
        return matchC && matchS;
      });
    }

    function updateVariantUI() {
      var v = findVariant();
      if (!v) return;

      // 更新隐藏 variant ID
      if (variantIdEl) variantIdEl.value = v.id;

      // 更新价格
      if (priceEl) {
        var saleEl    = priceEl.querySelector('.mt-mdnmd-pd__price-sale');
        var compareEl = priceEl.querySelector('.mt-mdnmd-pd__price-compare');
        if (saleEl) saleEl.textContent = fmtMoney(v.price);
        if (compareEl) {
          if (v.compare_at_price > v.price) {
            compareEl.textContent = fmtMoney(v.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
      }

      // 移动端：切换到变体关联图片
      if (v.featured_image && mobSlides.length) {
        var featSrc = v.featured_image.src || '';
        // 提取文件名核心（去掉尺寸后缀和查询参数）
        var fname = featSrc.split('?')[0].split('/').pop()
          .replace(/(_\d+x\d*)?(\.(jpg|jpeg|png|webp|gif))$/i, '');
        var idx = mobSlides.findIndex(function (el) {
          var img = el.querySelector('img');
          return img && img.src && img.src.indexOf(fname) !== -1;
        });
        if (idx >= 0) goTo(idx);
      }
    }

    root.querySelectorAll('.mt-mdnmd-pd__color-input').forEach(function (input) {
      input.addEventListener('change', function () {
        if (colorLabel) colorLabel.textContent = input.value;
        updateVariantUI();
      });
    });

    root.querySelectorAll('.mt-mdnmd-pd__size-input').forEach(function (input) {
      input.addEventListener('change', function () {
        if (sizeLabel) sizeLabel.textContent = input.value;
        updateVariantUI();
      });
    });

    /* --------------------------------------------------
       加购 / Buy Now
       -------------------------------------------------- */
    var form   = root.querySelector('form[data-type="add-to-cart-form"]');
    var addBtn = root.querySelector('.mt-mdnmd-pd__btn--cart');
    var buyBtn = root.querySelector('[data-mt-buy]');

    if (form) {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        var id  = parseInt((root.querySelector('.mt-mdnmd-product-variant-id') || {}).value || '0');
        var qty = Math.max(1, parseInt((root.querySelector('.mt-mdnmd-pd__qty-input') || {}).value || '1'));
        if (!id) { form.submit(); return; }
        try {
          if (addBtn) addBtn.disabled = true;
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
          });
          if (res.ok) {
            var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
            var count = (cart && cart.item_count) || 0;
            document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (el) {
              el.textContent = count > 0 ? ('(' + count + ')') : '';
            });
            sessionStorage.setItem('openCartAfterReload', 'true');
            location.reload();
          } else {
            throw new Error('add failed');
          }
        } catch (err) {
          console.error(err);
          alert('Failed to add. Please retry.');
        } finally {
          if (addBtn) addBtn.disabled = false;
        }
      }, { capture: true });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var id  = parseInt((root.querySelector('.mt-mdnmd-product-variant-id') || {}).value || '0');
        var qty = Math.max(1, parseInt((root.querySelector('.mt-mdnmd-pd__qty-input') || {}).value || '1'));
        if (!id) return;
        // 使用 Shopify 直接结账链接，仅结算当前商品，不经过购物车
        window.location.href = '/cart/' + id + ':' + qty;
      });
    }

    /* --------------------------------------------------
       手风琴互斥
       -------------------------------------------------- */
    root.querySelectorAll('.mt-mdnmd-pd__accordion').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (details.open) {
          root.querySelectorAll('.mt-mdnmd-pd__accordion').forEach(function (other) {
            if (other !== details) other.removeAttribute('open');
          });
        }
      });
    });
  }

  /* =====================================================
     DOM Ready：找到所有 config 节点并初始化
     ===================================================== */

  function boot() {
    document.querySelectorAll('[data-mt-mdnmd-config]').forEach(function (el) {
      initInstance(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
